import React from 'react';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faCalendar, faPencil } from '@fortawesome/pro-regular-svg-icons';
import parse from 'html-react-parser';
import { sanitizeContent } from 'services/helpers';
import ActivityCard from './ActivityCard';
import { IActivity } from '../types';
import { ACTIVITY_TYPE } from '../constants';
import { getDateWithTimeZone } from '../helpers';

export interface IActivityGroupProps {
    organizationId: string;
    dealId: number;
    activities: IActivity[]
}

const ActivityGroup = ({ activities, organizationId, dealId }: IActivityGroupProps) => activities.map(activity => {
    const {
        activityType, activityDate, id, createdAt,
    } = activity;
    const commonProps = { ...activity, organizationId, dealId };

    if (activityType === ACTIVITY_TYPE.EMAIL) {
        return (
            <ActivityCard
                {...commonProps}
                key={id}
                icon={faEnvelope}
                color="var(--success)"
                content={activity.body}
                header={(
                    <div>
                        <span className="text-success">
                            Email
                        </span>
                        <span className="text-muted">
                            {` from ${activity.fromEmail}`}
                            <br />
                            {`to ${activity.toEmail}`}
                        </span>
                    </div>
                )}
            />
        );
    }

    if (activityType === ACTIVITY_TYPE.MEETING) {
        return (
            <ActivityCard
                {...commonProps}
                key={id}
                icon={faCalendar}
                color="var(--success)"
                activityDate={createdAt}
                content={(
                    <div>
                        Scheduled:
                        {' '}
                        {getDateWithTimeZone(activityDate)}
                    </div>
                )}
                header={(
                    <div>
                        <span className="text-success">
                            Meeting
                        </span>
                        {
                            activity.title && (
                                <span className="text-muted">
                                    {` - ${activity.title}`}
                                </span>
                            )
                        }
                        {
                            activity.hostName && (
                                <span className="text-muted">
                                    {` by ${activity.hostName}`}
                                </span>
                            )
                        }
                    </div>
                )}
            />
        );
    }

    if (activityType === ACTIVITY_TYPE.NOTE) {
        return (
            <ActivityCard
                {...commonProps}
                key={id}
                icon={faPencil}
                color="var(--primary)"
                content={parse(sanitizeContent(activity.body))}
                header={(
                    <div>
                        <span className="text-primary">
                            Note
                        </span>
                        {'createdBy' in activity && activity.createdBy && (
                            <span className="text-primary">
                                {' '}
                                by
                                {' '}
                                {activity.createdBy.name}
                            </span>
                        )}
                    </div>
                )}
            />
        );
    }
    return (
        <ActivityCard
            {...commonProps}
            key={id}
            icon={faEnvelope}
            color="var(--success)"
            content={null}
            header={null}
        />
    );
});
export default ActivityGroup;
